import React, { createContext, useEffect, useState } from "react";
import Home from "../../Template/Home/Home";
import { useNavigate } from "react-router-dom";
import { userContext } from "../../Contexts/userContext";
import { Fetch } from "../../Hooks/Fetch";
import { missionURL, userInfo } from "../../Hooks/URL";
import useFetchWhen from "../../Hooks/useFetchWhen";
import useFetch from "../../Hooks/useFetch";

function HomePage() {
  const navigate = useNavigate();
  const [contextData, setContextData] = useState({
    page: "",
    data: "",
    link: "",
    user: "",
    missions: [],
  });

  const { data: missionData } = useFetch(missionURL);
  const { data: userData } = useFetchWhen(userInfo, !contextData?.user);

  useEffect(() => {
    if (!contextData?.user) {
      setContextData({
        ...contextData,
        user: userData?.data ?? "",
        missions: missionData?.data ?? [],
      });
    }
  }, [userData, missionData]);

  // useEffect(() => {
  //   if (localStorage.getItem("isLogged") == "false") navigate("/login");
  // }, []);

  return (
    <userContext.Provider value={{ contextData, setContextData }}>
      <Home />
    </userContext.Provider>
  );
}

export default HomePage;
